
<div>
  <!-- do not turn on autocomplete for password fields, it is a security risk -->
  <text-field
    :id="id"
    v-model="form.password"
    :name="name"
    :labelName="labelName"
    :aria-label="ariaLabel"
    :type="passwordVisible ? 'text' : 'password'"
    :status="status"
    autocomplete="off"
    iconStatic
    @blur="displayErrors"
  >
    <template #icon>
      <p id="password-text" aria-live="polite" class="sr-only">{{ passwordMessage }}</p>
      <button
        role="switch"
        class="password-field-icon"
        :aria-pressed="passwordVisible"
        aria-label="Show or hide password"
        aria-describedby="Password visibility toggle"
        type="button"
        @click="toggleVisibility"
      >
        <icon-show-password v-if="passwordVisible" />
        <icon-hide-password v-else />
      </button>
    </template>
  </text-field>
  <div v-if="allRequirementsMet" class="flex relative mt-4">
    <HelperText text="Nice work, your password is all set" :status="1" />
  </div>
  <div v-else class="mt-4">
    <ul v-for="(req, index) in requirements" :key="index" role="list" class="flex relative">
      <HelperText :text="generateHelperText(req)" :status="generateHelperTextStatus(req.validation, req.blur)" />
    </ul>
  </div>
</div>
